// 浊音数据： https://docs.qq.com/sheet/DUENveEhLUUZJckRP?tab=rtczqf&_t=1617155416916

/* eslint-disable */

const turbid = {
  'column': ['', '', '', '', ''],
  'row': {
    'key': ['が', 'ざ', 'だ', 'ば', 'ぱ'],
    'value': [
      [
        {
          'hiragana': 'が', // 平假名
          'katakana': 'ガ', // 片假名
          'romaji': 'ga', // 罗马音
        },
        {
          'hiragana': 'ぎ', // 平假名
          'katakana': 'ギ', // 片假名
          'romaji': 'gi', // 罗马音
        },
        {
          'hiragana': 'ぐ', // 平假名
          'katakana': 'グ', // 片假名
          'romaji': 'gu', // 罗马音
        },
        {
          'hiragana': 'げ', // 平假名
          'katakana': 'ゲ', // 片假名
          'romaji': 'ge', // 罗马音
        },
        {
          'hiragana': 'ご', // 平假名
          'katakana': 'ゴ', // 片假名
          'romaji': 'go', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ざ', // 平假名
          'katakana': 'ザ', // 片假名
          'romaji': 'za', // 罗马音
        },
        {
          'hiragana': 'じ', // 平假名
          'katakana': 'ジ', // 片假名
          'romaji': 'ji', // 罗马音
        },
        {
          'hiragana': 'ず', // 平假名
          'katakana': 'ズ', // 片假名
          'romaji': 'zu', // 罗马音
        },
        {
          'hiragana': 'ぜ', // 平假名
          'katakana': 'ゼ', // 片假名
          'romaji': 'ze', // 罗马音
        },
        {
          'hiragana': 'ぞ', // 平假名
          'katakana': 'ゾ', // 片假名
          'romaji': 'zo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'だ', // 平假名
          'katakana': 'ダ', // 片假名
          'romaji': 'da', // 罗马音
        },
        {
          'hiragana': 'ぢ', // 平假名
          'katakana': 'ヂ', // 片假名
          'romaji': 'ji', // 罗马音
        },
        {
          'hiragana': 'づ', // 平假名
          'katakana': 'ヅ', // 片假名
          'romaji': 'zu', // 罗马音
        },
        {
          'hiragana': 'で', // 平假名
          'katakana': 'デ', // 片假名
          'romaji': 'de', // 罗马音
        },
        {
          'hiragana': 'ど', // 平假名
          'katakana': 'ド', // 片假名
          'romaji': 'do', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ば', // 平假名
          'katakana': 'バ', // 片假名
          'romaji': 'ba', // 罗马音
        },
        {
          'hiragana': 'び', // 平假名
          'katakana': 'ビ', // 片假名
          'romaji': 'bi', // 罗马音
        },
        {
          'hiragana': 'ぶ', // 平假名
          'katakana': 'ブ', // 片假名
          'romaji': 'bu', // 罗马音
        },
        {
          'hiragana': 'べ', // 平假名
          'katakana': 'ベ', // 片假名
          'romaji': 'be', // 罗马音
        },
        {
          'hiragana': 'ぼ', // 平假名
          'katakana': 'ボ', // 片假名
          'romaji': 'bo', // 罗马音
        },
      ],
      [
        {
          'hiragana': 'ぱ', // 平假名
          'katakana': 'パ', // 片假名
          'romaji': 'pa', // 罗马音
        },
        {



          'hiragana': 'ぴ', // 平假名
          'katakana': 'ピ', // 片假名
          'romaji': 'pi', // 罗马音
        },
        {
          'hiragana': 'ぷ', // 平假名
          'katakana': 'プ', // 片假名
          'romaji': 'pu', // 罗马音
        },
        {
          'hiragana': 'ぺ', // 平假名
          'katakana': 'ペ', // 片假名
          'romaji': 'pe', // 罗马音
        },
        {
          'hiragana': 'ぽ', // 平假名
          'katakana': 'ポ', // 片假名
          'romaji': 'po', // 罗马音
        },
      ],
    ],
  }
};

export default turbid;
